// extracted by mini-css-extract-plugin
export default {"page":"MGPage_page__JaV0s","mobileViewport":"MGPage_mobileViewport__t7I57","body":"MGPage_body__EPWyU","content":"MGPage_content__TCT4L"};